<template>
  <table>
    <thead>
      <th class="checkbox" v-if="header.length != 0">
        <label>
          <input class="filled-in" type="checkbox" :checked="checkedAll" @click="selectAll">
          <span class="th-checkbox-span"></span>
        </label>
      </th>
      <th v-for="item in header" :key="item">
        {{item}}
      </th>
    </thead>
    <tbody v-if="body.length != 0">
      <tr v-for="(row, index) in body" :key="row.docId" @click.stop="selectRow(row.docId, row.columns)">
        <td class="checkbox" @click.stop="selectDocument(row.docId)"><label @click.prevent><input class="filled-in" type="checkbox" :checked="listChecked.includes(row.docId)"><span class="td-checkbox-span"></span></label></td>
        <td v-for="(item,  idx) in row.columns" :key="`${index}-${idx}`">
          <oba-label v-if="item.type == 'label'" 
            :label="item.value" 
            :color="getColorStatus(item.value)"
          />
          <span v-else>{{item.value}}</span>
        </td>
      </tr>
    </tbody>
  </table>
  <div v-if="body.length == 0" class="empty-data">No data has been input yet</div>
</template>

<script>
import Label from '@/components/label'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapGettersConfig } = createNamespacedHelpers('config')

export default {
  name: 'oba-table-sub-items',
  emits: ['selectRow', 'selectDoc'],
  components: {
    'oba-label': Label,
  },
  props: {
    collection: {
      type: String,
      required: true
    },
    header:{
      type: Array,
      required : false,
      default: []
      /** Sample for header table structure
       *  data = [ 
            {label : "Label Name" , width: "15%"}, 
            {label : "Label Name 2" , width: "15%"}
          ]
      * */
    },
    body: {
      type:Array,
      required : false,
      default: []
      /** Sample for body table structure
       * data = [
       *  {
            docId: 'WQJENWMMDMsss',
            columns: [ 
              {fieldName: "ID", value: "installation-OBA-100",  type: "text"},
              {fieldName: "Name", value: "Done",  type: "label"},  
       *    ]
          }
        ]
      * */
    },
  },
  data() {
    return {
      listChecked: [],
      checkedAll: false,
    }
  },
  computed: {
    ...mapGettersConfig([
      'getStatuses'
    ])
  },
  methods:{
    selectDocument(docId) {
      const index = this.listChecked.indexOf(docId)
      if (index !== -1) {
        this.listChecked.splice(index, 1)
      } else {
        this.listChecked.push(docId)
      }
      this.$emit('selectDoc', this.listChecked)
    },
    selectAll() {
      this.checkedAll = !this.checkedAll
      if (this.checkedAll) {
        this.listChecked = this.body.map(doc => doc.docId)
      } else {
        this.listChecked = []
      }
      this.$emit('selectDoc', this.listChecked)
    },
    selectRow(id, item){
      let rowData = {}
      Object.values(item).forEach( data =>{
        rowData[data.fieldName] = data.value
      })
      rowData['docId'] = id
      this.$emit('selectRow', rowData)
    }, 
    getColorStatus(value){
      /**
       * get hex color status from config
       */
      const listStatus = this.getStatuses(this.collection)
      let color = null
      listStatus.forEach( item =>{
        if(item.name.toLowerCase() == value.toLowerCase()) color = item.bgColor
      })
      return color
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
